/*
 * Important note:
 * This validator is used in `@homer.core/task` from within a
 * WebWorker, so there are no additional imports allowed here,
 */
const isTransferable = (value) => {
    return (
        ("ArrayBuffer" in globalThis && value instanceof ArrayBuffer) ||
        ("MessagePort" in globalThis && value instanceof MessagePort) ||
        ("ImageBitmap" in globalThis && value instanceof ImageBitmap)
    );
};

export default isTransferable;
